import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const ClockIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg viewBox="0 -960 960 960" width="1em" height="1em">
				<g fill="currentColor">
                <path d="m627-287 45-45-159-160v-201h-60v225l174 181ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-82 31.5-155t86-127.5Q252-817 325-848.5T480-880q82 0 155 31.5t127.5 86Q817-708 848.5-635T880-480q0 82-31.5 155t-86 127.5Q708-143 635-111.5T480-80Zm0-400Zm0 340q140 0 240-100t100-240q0-140-100-240T480-820q-140 0-240 100T140-480q0 140 100 240t240 100Z"/>
				</g>
			</svg>
		</Icon>
    )
}

export default ClockIcon;